import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';

const Educations = () => {
    return (
        <div>
            <div class="card">
                <div class="card-content">
                    <h6>
                        <strong>EDUCATION</strong>
                    </h6>
                    <table class="striped">
                        <thead>
                            <tr>
                                <th>Certificate</th>
                                <th>Date</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Vinh University</td>
                                <td>Agu 2018</td>
                                <td>
                                    <Link
                                        to="/details"
                                        class="btn blue lighten-2"
                                    >
                                        View
                                    </Link>
                                </td>
                            </tr>
                            <tr>
                                <td>Dien Chau 2</td>
                                <td>May 2016</td>
                                <td>
                                    <Link
                                        to="/details"
                                        class="btn blue lighten-2"
                                    >
                                        View
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Educations;
